import { RequestProvider } from '@/shared/providers/request.provider';
import { CALENDAR_API } from '../values/calendar.values'

/* Deprecated: This service is not using in the app */
class CalendarServicesClass {

  /* Get Methods */
  public getCalendars(includeUsername: boolean): Promise<any> {
    return new Promise((resolve,reject) => {
      RequestProvider.get(`${CALENDAR_API.CALENDAR_BY_USER}?includeUsername=${includeUsername}`)
          .then((res: any) => {
            resolve(res.calendars);
          })
          .catch(() => {
            reject();
          });
    });
  }

  public getCalendarsAndConfig(includeUsername: boolean): Promise<any> {
    return new Promise((resolve,reject) => {
      RequestProvider.get(`${CALENDAR_API.CALENDAR_BY_USER}?includeUsername=${includeUsername}`)
          .then((res: any) => {
            resolve(res);
          })
          .catch(() => {
            reject();
          });
    });
  }

  public getEvents(params: any): Promise<any> {
    return new Promise((resolve,reject) => {
      RequestProvider.get(`${CALENDAR_API.CALENDAR_ALL}?endDate=${params.end}&startDate=${params.start}&calendars=${params.calendars}`)
          .then((res: any) => {
            resolve(res.calendars);
          })
          .catch(() => {
            reject();
          });
    });
  }
/*
  public getCalendar(dates: any): Promise<any> {
    return new Promise((resolve,reject) => {
      RequestProvider.get(`${CALENDAR_API.CALENDAR_INFO}?endDate=${dates.endAt}&startDate=${dates.startAt}`)
      .then((res: any) => {
        resolve(res.data);
      })
      .catch(() => {
        reject();
      });
    });
  }
*/
  /* Post Methods */
  public createEventOrTask(calendarData: any , calendarId: string , type: string): Promise<any> {
    return new Promise((resolve,reject) => {
      RequestProvider.post(`${CALENDAR_API.CALENDAR_INFO}/${calendarId}/${type}`, calendarData )
      .then((res: any) => {
        resolve(res);
      })
      .catch(() => {
        reject();
      });
    });
  }

  /* Put Methods */
  public updateEventOrTask(data: any , calendarId: string, uid: string , type: string): Promise<any> {
    return new Promise((resolve, reject) => {
      RequestProvider.put(`${CALENDAR_API.CALENDAR_INFO}/${calendarId}/${type}/${uid}` , data )
      .then((res: any) => {
        resolve(res);
      })
      .catch(() => {
        reject();
      });
    });
  }

  public updateCalendar(data: any): Promise<any> {
    return new Promise((resolve, reject) => {
      RequestProvider.put(`${CALENDAR_API.CALENDAR_INFO}/${data.calendarId}` , data )
          .then((res: any) => {
            resolve(res);
          })
          .catch(e => {
            reject(e);
          });
    });
  }

  /* Delete Methods */
  public removeEventOrTask(calendarId: string, uid: string , type: string): Promise<void> {
    return new Promise((resolve,reject) => {
      RequestProvider.remove(`${CALENDAR_API.CALENDAR_INFO}/${calendarId}/${type}/${uid}`)
      .then(() => {
        resolve();
      })
      .catch(() => {
        reject();
      });
    });
  }

  public async getClassScheduleItems(params: { start: string, end: string, calendars: string[] }): Promise<any> {
    return await RequestProvider.get(`${CALENDAR_API.CLASS_SCHEDULE}?calendarIds=${params.calendars}&startDate=${params.start}&endDate=${params.end}&tz=${Intl.DateTimeFormat().resolvedOptions().timeZone}`);
  }


}

export const CalendarServices = new CalendarServicesClass();
